import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import imgNewsletter2537 from 'url:../../../../../resource/images/newsletter_2537.png';
import { nsNewsletter } from '@/app/i18n/namespaces';

// Sprint number : 2537
const Sp2537Newsletter090925 = ({ params }) => {
    const { t: translate } = useTranslation(nsNewsletter);

    return (
        <div className='space-y-4'>
            <div className='space-y-4'>
                <p className='font-semibold text-lg text-primary'>
                    {translate('editions.sp2537.title')}
                </p>
                <p>
                    <Trans t={translate} i18nKey='editions.sp2537.p1' components={{ 1: <b /> }} />
                </p>
                <p>{translate('editions.sp2537.changes')}</p>
                <ul className='list-disc ml-8'>
                    <li>{translate('editions.sp2537.li1')}</li>
                    <li>{translate('editions.sp2537.li2')}</li>
                    <li>{translate('editions.sp2537.li3')}</li>
                </ul>
            </div>
            <img onLoad={() => params.handleImageLoad()}
                alt='Newsletter 2537 img'
                src={imgNewsletter2537} /><br /><br />
        </div>
    );
};

Sp2537Newsletter090925.propTypes = {
    params: PropTypes.shape({
        handleImageLoad: PropTypes.func.isRequired
    }).isRequired
};

export default Sp2537Newsletter090925;
